// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"7f9d64db","513":"97ea45e4","661":"7728be7b","706":"711ede07","726":"2b58ec26","991":"e7da2c0d"}[chunkId] + ".chunk.js";
};